export class HttpCancelledError extends Error {
  constructor(public readonly meta: any) {
    super('Request cancelled');
    this.name = 'HttpCancelledError';
  }
}
